import React from 'react';
import LiveStreamWaitingRoom from './components/LiveStreamWaitingRoom';
import VideoNotFound from './components/VideoNotFound';
import { LiveEventInfos } from '../../interfaces/liveEventInfos.interface';

export interface VideoErrorDisplayProps {
  isLiveStream?: boolean;
  posterUrl?: string;
  message: string;
  viewportHeight: number;
  eventInfos?: LiveEventInfos; // Optional, used for live streams
  cooldown?: boolean; // Optional, used for live streams
  cooldownLeft?: number; // Optional, used for live streams
}

const defaultEventInfos: LiveEventInfos = { title: '', description: '', startDate: '', endDate: '' };

const VideoErrorDisplay: React.FC<VideoErrorDisplayProps> = ({
  isLiveStream,
  message,
  viewportHeight,
  eventInfos = defaultEventInfos,
  posterUrl = 'defaultPosterUrl', // Default value if posterUrl is not provided
  cooldown,
  cooldownLeft
}) => (
  <>
    {isLiveStream && posterUrl ? (
      <LiveStreamWaitingRoom
        posterUrl={posterUrl}
        viewportHeight={viewportHeight}
        eventInfos={eventInfos}
        cooldown={cooldown}
        cooldownLeft={cooldownLeft}
      />
    ) : (
      <VideoNotFound message={message} viewportHeight={viewportHeight} />
    )}
  </>
);

export default VideoErrorDisplay;
